export default __webpack_public_path__ + "static/media/GTB.02efc872.jpg";